// Fixed colour per product — a product keeps the SAME colour everywhere (every chart,
// every page), regardless of its usage rank or the current filter. This is the
// "colour table": edit a value below to change that product's colour. Products not
// listed fall back to a stable colour derived from their name, so they're still
// consistent from run to run (never rank-based).
import { CHART_COLORS } from './constants';

export const PRODUCT_COLORS = {
  'S1 N-Able Control': '#2563eb',
  'Keepit MBX': '#f59e0b',
  'S1 N-Able Complete': '#14b8a6',
  'Cove MBX': '#a855f7',
  'Cove Workstation': '#ef4444',
  'S1 CW SOC Control': '#0ea5e9',
  'Cove V Server': '#84cc16',
  'S1 CW Control': '#ec4899',
  'N-Central': '#f97316',
  'Cove P Server': '#6366f1',
  'S1 Magen Control': '#10b981',
  'Perception Point Mail': '#eab308',
  'S1 Magen Complete': '#8b5cf6',
  'Lookout ESE': '#06b6d4',
  'S1 CW SOC Complete': '#d946ef',
  'S1 CW Complete': '#f43f5e',
  'Perception Point Web': '#22c55e',
};

// Stable colour for a product: the table value if defined, else a deterministic
// hash of the name into the palette (same product → same colour, always).
export function colorForProduct(name) {
  if (PRODUCT_COLORS[name]) return PRODUCT_COLORS[name];
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return CHART_COLORS[h % CHART_COLORS.length];
}
